<template>
  <div class="bind-acc">
    <div class="card-wrp">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span style="font-weight:bold">{{ $t('RewardCenter.BindAccPage.CardTitle') }}</span>
        </div>
        <div class="tip-box">
            <div>{{ $t('RewardCenter.BindAccPage.BigTip') }}<a style="color:#EAAA83" href="mailto:support@fotoncard.com" target="_blank">support@fotoncard.com</a>，{{ $t('RewardCenter.BindAccPage.SmallTip') }}</div>
        </div>
        <div class="c-box">
          <div class="fm-box">
            <div class="fm-box-item">
              <div class="lb">{{ $t('RewardCenter.BindAccPage.AccountType') }}</div>
              <el-select v-model="zfb">
                <el-option :label="$t('RewardCenter.BindAccPage.AliPay')" value="AliPay">{{ $t('RewardCenter.BindAccPage.AliPay') }}</el-option>
              </el-select>
            </div>
            <div class="fm-box-item">
              <div class="lb">{{ $t('RewardCenter.BindAccPage.AccountNumber') }}</div>
              <!-- <el-select v-model="formData.Alipay.AccountNumber" allow-create filterable>
                <el-option
                  v-for="(item, index) in wOption"
                  :key="index"
                  :label="item.open_id"
                  :value="item.open_id"
                >
                </el-option>
              </el-select> -->
              <el-input
                style="width: 202px"
                v-model="formData.Alipay.AccountNumber"
                type="text"
              ></el-input>
            </div>
            <!-- <div style="width: 456px; margin-left: auto;font-size:12px">
              <el-alert
                type="warning"
                style="font-size:12px"
                :title="$t('RewardCenter.BindAccPage.AccountNumberTip')"
              ></el-alert>
            </div> -->
            <!-- <div class="fm-box-item" v-show="showAccName">
              <div class="lb">
                {{ $t('RewardCenter.BindAccPage.FullAccountName') }}<el-tooltip
                  class="item"
                  effect="dark"
                  :content="$t('RewardCenter.BindAccPage.FullAccountNameTip')"
                  placement="top-start"
                >
                  <i
                    style="color: #e6a23c"
                    class="el-icon-question qtstyle"
                  ></i>
                </el-tooltip>
              </div>
              <el-input
                style="width: 202px"
                v-model="acc_name"
                type="text"
              ></el-input>
            </div> -->
            <div class="btn-box">
                <!-- <el-button @click="confirmInfo" style="width:59%;background:#00BEA4;color:#fff">{{ $t('RewardCenter.BindAccPage.Confirm') }}</el-button> -->
                <button
                style="width:59%"
              @click="confirmInfo"
              class="btn custer sbtn"
              type="button"
            >
              {{ $t('RewardCenter.BindAccPage.Confirm') }}
            </button>
            </div>
          </div>
        </div>
      </el-card>
    </div>
    <AliyunCaptchaGuard
      ref="bindWithdrawCaptchaGuard"
      cache-key="bind-alipay-withdraw-account-captcha"
    />
  </div>
</template>

<script>
import { getAliWithdrawInfo } from "../../api/http";
import { Loading } from "element-ui";
import AliyunCaptchaGuard from '@/components/AliyunCaptchaGuard.vue'
export default {
  components: {
    AliyunCaptchaGuard
  },
  data() {
    return {
      wOption: "",
      zfb: "",
      acc_name: "",
      showAccName: false,
      formData: {
        Alipay: {
          AccountNumber: null,
        },
      },
    };
  },
  created() {
    this.getInfo();
  },
  watch: {
    //   顯示隱藏完整賬戶名
      "formData.Alipay.AccountNumber": {
          handler(val) {
              if(val != null) {
                  this.showAccName = true
              }else {
                  this.showAccName = false
              }
          }
      }
  },
  methods: {
    // 获取提现信息
    getInfo() {
      let obj = {
        type: "get_ali_withdraw_info",
        uid: localStorage.getItem("uid"),
      };
      getAliWithdrawInfo(obj).then((res) => {
        console.log("res==>", res);
        if (res.code == 200) {
          this.wOption = res.data.withdraw_account;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    confirmInfo() {
        if(this.formData.Alipay.AccountNumber == null || this.zfb == "") {
            return
        }
        let loading = null;
      this.$refs.bindWithdrawCaptchaGuard.execute((captchaVerifyParam) => {
        const captchaParam = typeof captchaVerifyParam === 'string'
          ? captchaVerifyParam
          : JSON.stringify(captchaVerifyParam)
        loading = Loading.service({ fullscreen: true });
        return this.$axios({
          method: "POST",
          url: `/request/user.php?type=bind_agent_withdraw_acc&uid=${localStorage.getItem('uid')}&captcha_verify_param=${encodeURIComponent(captchaParam)}`,
          // url: `/request/user.php`,
          headers: { "Content-Type": "application/json;charset=UTF-8" },
          // data: formData,
          data: JSON.stringify(this.formData),
        })
      }, {
        isSuccess: (res) => Number(res.data.code) === 200
      }).then((res) => {
        if(res.data.code == 200) {
          loading.close()
          this.$message.success(res.data.message)
          // this.getInfo()
          this.$router.push("/reward-center/account")
        }else if(res.data.code == 401) {
          loading.close()
          this.$message.warning(res.data.message)
          this.$router.push("/pages/login")
        }
        else{
          loading.close()
          // this.$message.error(res.data.message)
          this.$message({
          type: "error",
          message: res.data.message,
          duration: 5000
        });
        }
      }).catch(() => {
        if (loading) loading.close()
      })
    }
  },
};
</script>

<style scoped lang="scss">
.bind-acc {
  padding-left: 2.6rem;
  height: 100vh;
  background: #fff;
  .card-wrp {
    width: 83%;
    margin: 0 auto;
    overflow: hidden;
    padding-top: 2rem;
    padding-bottom: 2rem;
    .tip-box{
        padding: 10px 20px;
        background: #FDF6EC;
        color: #E6AA6F;
        text-align: center;
        font-size: 14px;
    }
  }
  .c-box {
    padding: 0 300px;
    .fm-box {
      .fm-box-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0.5rem 0;
        .lb {
          width: 150px;
          text-align: right;
        }
      }
      .btn-box{
          text-align: center;
          margin-top: 1rem;
          margin-left: 5rem;
      }
    }
  }
}
.sbtn:hover {
  background: rgba(0, 190, 164, 0.8) !important;
}
.sbtn:focus {
  border-color: #00bea4;
  box-shadow: 0 0 0 0.25rem rgba(0, 190, 164, 0.5) !important;
}
.custer {
  background: #00bea4;
  color: #fff;
  width: 100%;
  outline: 0;
}
</style>
